export default "__VITE_ASSET__BmPWKomC__"